<script lang="ts" setup>
import type { CartItem } from '~/types/Cart';

const route = useRoute();
const { isMobile } = useBreakpoints();
const isCartShareModalOpen = ref(false);
const cartStore = useCartStore();
const catalogStore = useCatalogStore();

const isRecipient = ref(false);
const offersFromShareLink = ref<CartItem[]>([]);

async function getCartItemsFromShareLink() {
  if (route.query.share) {
    isRecipient.value = true;

    const offers = await catalogStore.getOffersList(String(route.query.share));
    if (offers.length) {
      offersFromShareLink.value = offers.map((offer) => ({ id: offer.id, count: 1, data: offer }) as CartItem);
    }

    isCartShareModalOpen.value = true;
  }
}

onMounted(async () => {
  await nextTick();
  await getCartItemsFromShareLink();
});

const ogImage = computed(
  () =>
    offersFromShareLink.value[0]?.data.offer_images[0]?.url ??
    'https://688516.selcdn.ru/Pics/774377/%D0%BB%D0%BE%D0%B3%D0%BE6.png',
);

const { appUrl } = useRuntimeConfig().public;

useHead({
  meta: [
    { property: 'og:title', content: 'Корзина – Hellride.ru' },
    {
      property: 'og:description',
      content:
        'Корзина – Hellride.ru → Большой выбор трюковых самокатов, запчастей и street wear брендов. Доставляем по всей РФ. Помогаем в подборе. Предоставляем скидки и промокоды для выгодных покупок',
    },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: appUrl + route.fullPath },
    { property: 'og:site_name', content: 'Hellride.ru' },
    { property: 'og:locale', content: 'ru_RU' },
    {
      property: 'og:image',
      content: ogImage.value,
    },
  ],
});

const items = computed(() => (isRecipient.value ? offersFromShareLink.value : cartStore.selectedCartItems));
</script>

<template>
  <div>
    <button
      class="flex items-center gap-2"
      @click="isCartShareModalOpen = true"
    >
      <SvgoShare
        :font-controlled="false"
        class="size-6"
        filled
      />

      <span v-if="!isMobile">Поделиться корзиной</span>
    </button>

    <CartShareModal
      v-model="isCartShareModalOpen"
      :is-recipient="isRecipient"
      :items
    />
  </div>
</template>
